<ng-container *ngIf="viewModel$ | async as viewModel">

  <ng-template
    #jobSectionTemplate
    let-jobs="jobs"
    let-title="title"
    let-icon="icon"
  >
    <section *ngIf="jobs.length">
      <h4>{{ title }}&nbsp;</h4>
      <a
        class="access-item"
        pContextMenu="contextMenu"
        [contextMenu]="menuItems"
        *ngFor="let job of jobs"
        [routerLink]="job.jobLink"
        [queryParams]="{ zone: job.contextZone }"
      >
        <i ngClass="pi {{ icon }}"></i>
        <div class="access-info">
          <div>
            <span class="name">{{ job?.users | jobCustomer }}</span>
            <i
              *ngIf="job.hasChanges"
              class="pi pi-circle-on unsaved-icon"
              pTooltip="Unsaved Changes"
            ></i>
          </div>
          <span class="details"
            >{{ job.stage | titlecase }} | {{ job.code }}</span
          >
        </div>
      </a>
    </section>
  </ng-template>

  <div class="quick-access-content">
    <h6 class="no-jobs" *ngIf="viewModel.isEmpty">
      No recent jobs.<br />
      Open a job to get started!
    </h6>

    <ng-container
      *ngTemplateOutlet="
        jobSectionTemplate;
        context: {
          jobs: viewModel.pinnedJobs,
          title: 'Pinned',
          icon: 'pi-bookmark',
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        jobSectionTemplate;
        context: {
          jobs: viewModel.recentJobs,
          title: 'Recents',
          icon: 'pi-clock',
        }
      "
    ></ng-container>

  </div>

  <!-- PrimeNG ContextMenu -->
  <!-- <p-contextMenu #contextMenu [model]="menuItems"></p-contextMenu> -->
</ng-container>